import { useState } from "react";
import ModuleHeader from "../../components/ModuleHeader";
import CreateBroadcastTab from "./CreateBroadcastTab";
import BroadcastHistoryTab from "./BroadcastHistoryTab";

export default function Communications() {
  const [activeTab, setActiveTab] = useState("create-broadcast");
  const [historyRefreshKey, setHistoryRefreshKey] = useState(0);

  const handleBroadcastSent = () => {
    setHistoryRefreshKey((k) => k + 1);
    setActiveTab("broadcast-history");
  };

  return (
    <div>
      <ModuleHeader
        title="Communications"
        tabs={[
          { key: "create-broadcast", label: "Create Broadcast" },
          { key: "broadcast-history", label: "Broadcast History" },
        ]}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      <div style={{ padding: "16px 0" }}>
        {activeTab === "create-broadcast" && (
          <CreateBroadcastTab onSent={handleBroadcastSent} />
        )}
        {activeTab === "broadcast-history" && (
          <BroadcastHistoryTab refreshKey={historyRefreshKey} />
        )}
      </div>
    </div>
  );
}
